

export default function PaymentError() {

    return (
        <div className="popup-bg">
            <div className="popup-window bg-white p-8 flex flex-col gap-3 items-center max-w-md">
                <img className="h-24" alt="logo" src="/iconslimsvet/logo.png" />
                <p className="font-medium text-dark-green text-md text-center">Désolé, une erreur est survenue. Nous n'avons pas pu traiter votre paiement. Veuillez vérifier vos informations de paiement et réessayer. Si le problème persiste, contactez notre support par email à info@limsvet.be</p>
            </div>
        </div>
    );
}